import React from 'react';
import { db } from '../../..';
import { ref, onValue, get } from 'firebase/database';
// import { SyncLoader } from 'react-spinners';
import {APIProvider, Map as MapModule, AdvancedMarker, Pin} from '@vis.gl/react-google-maps';
import TeamInfoModal from '../TeamInfoModal';
import { ClipLoader } from 'react-spinners';
import { Fragment } from 'react';

const Map = (props) => {
  const [gameLog, setGameLog] = React.useState({});
  const [markers, setMarkers] = React.useState([]);
  const icons = ["🏃‍♂️", "👹"];
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalTeam, setModalTeam] = React.useState(null);
  const [modalLocation, setModalLocation] = React.useState(null);
  const [members, setMembers] = React.useState(null);
  const mapRef = React.useRef(null);
  const [loadingCurrentLocation, setLoadingCurrentLocation] = React.useState(false);
  const [teams, setTeams] = React.useState(null);

  // チーム選択フィルタ
  const [selectedTeam, setSelectedTeam] = React.useState(null); // null: すべて, number: チームID

  // 時点を選ぶスライダー
  const [sliderValue, setSliderValue] = React.useState(0); // 時点を選ぶスライダーの値
  const [sliderMax, setSliderMax] = React.useState(100); // 最後の時刻
  const [sliderMin, setSliderMin] = React.useState(0); // 最初の時刻

  // マップの中心座標
  const [center, setCenter] = React.useState(
    props.center || {
      lat: 35.681236, // 東京駅の緯度
      lng: 139.767125, // 東京駅の経度
      zoom: 13, // ズームレベル
    }
  );

  const [defaultCenter] = React.useState(
    props.center || {
      lat: 35.681236, // 東京駅の緯度
      lng: 139.767125, // 東京駅の経度
      zoom: 13, // ズームレベル
    }
  );

  // 現在地
  const [currentLocation, setCurrentLocation] = React.useState({
    lat: 35.681236, // 東京駅の緯度
    lng: 139.767125, // 東京駅の経度
    zoom: 13, // ズームレベル
  });

  // マップの初期化
  React.useEffect(() => {
    setCenterToCurrentLocation();
  }, []);

  //ゲームログ・マップ中心座標の取得
  React.useEffect(() => {
    //ゲームログ
    const gameLogRef = ref(db, 'gameLogs/' + props.gameId + '/history');
    onValue(gameLogRef, (snapshot) => {
      if (snapshot.exists()) {
        setGameLog(snapshot.val());
        makeMarkers(snapshot.val());
      }
    });

    //マップ中心座標の取得
    // const gameMapRef = ref(db, 'games/' + props.gameId + "/info/mapCenter");
    // get(gameMapRef).then((snapshot) => {
    //   console.log(snapshot.val())
    //   if (snapshot.exists()) {
    //     setCenter(snapshot.val());
    //   }
    // });

    //メンバー情報の取得
    const membersRef = ref(db, 'games/' + props.gameId + '/members');
    get(membersRef).then((snapshot) => {
      if (snapshot.exists()) {
        setMembers(snapshot.val());
      }
    });

    // makeMarkersはselectedTeamにも依存する関数のため、依存に含めるとチームフィルタ変更のたびに
    // このマウント時専用の初期化処理（ゲームログ購読・メンバー取得）が再実行されてしまう。
    // gameIdはpropsとして不変のため、マウント時のみ実行する意図的な設計として除外する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // チーム選択が変更された時にマーカーを更新
  React.useEffect(() => {
    if (gameLog && Object.keys(gameLog).length > 0) {
      makeMarkers(gameLog);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTeam, gameLog]);

  // マーカーの更新
  const updateMarkers = (event) => {
    setSliderValue(event.target.value);
    const newMarkers = [];

    // チームデータの取得
    if(!teams) {alert("チームデータが取得できませんでした"); return;}

    // チームごとの位置情報を取得（スライダーで選んだ時刻に最も近い位置情報）
    Object.keys(gameLog).forEach((historyKey) => {
      const history = gameLog[historyKey];

      if (history.report && history.report.position) {
        // チームフィルタが適用されている場合のチェック
        if (selectedTeam !== null && history.teamId !== selectedTeam) {
          return; // 選択されたチーム以外は除外
        }

        if(new Date(history.time).getTime() <= event.target.value) {
          if(newMarkers[history.teamId]) {
            // 既に登録されている場合は、新しい時刻であれば、新しい位置情報を登録
            if(newMarkers[history.teamId].time < history.time) {
              newMarkers[history.teamId] = {
                time: history.time,
                position: history.report.position,
                team: teams[Number(history.teamId)]
              }
            }
          } else {
            // まだ登録されていない場合は、新規登録
            newMarkers[history.teamId] = {
              time: history.time,
              position: history.report.position,
              team: teams[Number(history.teamId)]
            }
          }
        }
      }
    });

    // console.log(newMarkers);

    setMarkers((prev) => newMarkers);
  }


  // マーカーの用意
  const makeMarkers = async (histories) => {
    // チームデータの取得
    const teamsRef = ref(db, 'gameLogs/' + props.gameId + '/teams');
    let teams = {};
    await get(teamsRef).then((snapshot) => {
      if (snapshot.exists()) {
        teams = snapshot.val();
        setTeams(snapshot.val());
      }
    });

    if(!teams) {alert("チームデータが取得できませんでした"); return;}

    const newMarkers = [];

    let minTime = null;
    let maxTime = null;

    // チームごとの最新の位置情報を取得
    Object.keys(histories).forEach((historyKey) => {
      const history = histories[historyKey];

      if (history.report && history.report.position) {
        // チームフィルタが適用されている場合のチェック
        if (selectedTeam !== null && history.teamId !== selectedTeam) {
          return; // 選択されたチーム以外は除外
        }

        // 最初の時刻と最後の時刻を更新
        if(minTime === null || minTime > new Date(history.time).getTime()) {
          minTime = new Date(history.time).getTime();
        }

        if(maxTime === null || maxTime < new Date(history.time).getTime()) {
          maxTime = new Date(history.time).getTime();
        }

        if(newMarkers[history.teamId]) {
          // 既に登録されている場合は、新しい時刻であれば、新しい位置情報を登録
          if(newMarkers[history.teamId].time < history.time) {
            newMarkers[history.teamId] = {
              time: history.time,
              position: history.report.position,
              team: teams[Number(history.teamId)]
            }
          }
        } else {
          // まだ登録されていない場合は、新規登録
          newMarkers[history.teamId] = {
            time: history.time,
            position: history.report.position,
            team: teams[Number(history.teamId)]
          }
        }
      }
    });

    setMarkers((prev) => newMarkers);

    console.log(maxTime, minTime);
    setSliderMax(maxTime);
    setSliderMin(minTime);
    setSliderValue(maxTime);
    console.log(newMarkers);
  }

  // 中心座標を現在地にする
  const setCenterToCurrentLocation = () => {
    setLoadingCurrentLocation(true);

    navigator.geolocation.getCurrentPosition((position) => {
      setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        zoom: 13,
      });
      setCurrentLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        zoom: 13,
      });
      setLoadingCurrentLocation(false);
    });
  };

  return (
    <div className='relative'>
      <button onClick={() => setCenterToCurrentLocation()} className='absolute end-1.5 top-14 flex items-center z-10  px-2.5 m-1 bg-white w-10 h-10 text-lg border shadow text-gray-700' title="現在地">
        {
          loadingCurrentLocation ? <ClipLoader color={'#673ab7'} size={18} /> : <i className='bi bi-geo-alt'></i>
        }
      </button>
      
      {/* チーム選択フィルタ */}
      <div className='absolute start-1.5 top-2 z-10 m-1'>
        <select 
          className='bg-white border shadow rounded px-2 py-1 text-sm text-gray-700 focus:outline-purple-300'
          value={selectedTeam || ''}
          onChange={(e) => setSelectedTeam(e.target.value === '' ? null : parseInt(e.target.value))}
        >
          <option value="">すべてのチーム</option>
          {teams && Object.keys(teams).map((teamId) => (
            <option key={teamId} value={teamId}>
              {teams[teamId].name}
            </option>
          ))}
        </select>
      </div>
      
      <APIProvider apiKey={process.env.REACT_APP_API_KEY}>
        <MapModule
          style={{width: '100%', height: '640px'}}
          center={{lat: center.lat, lng: center.lng}}
          zoom={center.zoom}
          defaultCenter={{lat: defaultCenter.lat, lng: defaultCenter.lng}}
          defaultZoom={defaultCenter.zoom}
          disableDefaultUI={true}
          fullscreenControl={true}
          mapId={"e65c1510a4dd112b"} 
          onLoad={(map) => (mapRef.current = map)} // 地図の参照を保存
          onBoundsChanged={(e) => {
            // console.log(e)
            const newCenter = {
              lat: e.detail.center.lat,
              lng: e.detail.center.lng,
              zoom: e.detail.center.zoom
            };
            setCenter(newCenter); // 地図移動時に state を更新
          }}
        />

        {/* マーカー */}
        {markers && markers.map((marker, index) => {
          return (
            <Fragment key={index}>
              {/* チームのピン */}
              <AdvancedMarker
                key={index}
                position={{lat: marker.position.lat, lng: marker.position.lng}}
                onClick={() => {setModalLocation(marker); setModalTeam(marker.team); setIsOpen(true);}}
              >
                <Pin background={marker.team && marker.team.color} glyphColor={"black"} borderColor={'#555'} glyph={marker.team && icons[marker.team.role]} scale={1.2} />
              </AdvancedMarker>

              {/* チームの名前 */}
              {/* チームデータが取得できないケース（データ不整合等）でも描画がクラッシュしないよう、
                  marker.teamの存在を必ず確認してから参照する */}
              <AdvancedMarker
                position={{lat: marker.position.lat, lng: marker.position.lng}} // 少しずらして表示
                onClick={() => {setModalLocation(marker); setModalTeam(marker.team); setIsOpen(true);}}
              >
                <div className={`text-center min-w-40 text-sm text-gray-800/70`} style={{transform: 'translateY(105%)'}}>
                  {marker.team && (<>{marker.team.name} {marker.team.score} pt</>)}
                </div>
              </AdvancedMarker>

              {/* アイテム待機中 */}
              {(marker.team && marker.team.usingCard && (new Date(marker.team.usingCard.waitingLimit) > new Date())) && (
                <AdvancedMarker
                  position={{lat: marker.position.lat, lng: marker.position.lng}} // 少しずらして表示
                  onClick={() => {setModalLocation(marker); setModalTeam(marker.team); setIsOpen(true);}}
                >
                  <div className='bg-purple-600/40 text-white p-1 rounded-md text-xs shadow-md min-w-32' style={{transform: 'translateY(160%)'}}>
                    <i className='bi bi-hourglass-split me-1'></i>
                    {marker.team.usingCard.name} <span className='text-xs'>待機中</span>
                  </div>
                </AdvancedMarker>
              )}

              {/* アイテム使用中 */}
              {(marker.team && marker.team.usingCard && (new Date(marker.team.usingCard.limit) > new Date()) && (!marker.team.usingCard.waitingLimit || new Date(marker.team.usingCard.waitingLimit) < new Date())) && (
                <AdvancedMarker
                  position={{lat: marker.position.lat, lng: marker.position.lng}} // 少しずらして表示
                  onClick={() => {setModalLocation(marker); setModalTeam(marker.team); setIsOpen(true);}}
                >
                  <div className='bg-purple-600/60 text-white p-1 rounded-md text-xs shadow-md min-w-32' style={{transform: 'translateY(160%)'}}>
                    <i className='bi bi-hourglass-split me-1'></i>
                    {marker.team.usingCard.name}
                  </div>
                </AdvancedMarker>
              )}
            </Fragment>
          );
        })}

        {/* 現在地のマーカー */}
        <AdvancedMarker
          position={{lat: currentLocation.lat, lng: currentLocation.lng}}
        >
          <div className='text-blue-500 border-2 border-white rounded-full bg-blue-500/80 w-4 h-4' style={{transform: 'translateY(50%) translateX(0%)'}}></div>
        </AdvancedMarker>
      </APIProvider>

      {/* 時点を選ぶスライダー */}
      <div className='absolute bottom-3 left-1/2 transform -translate-x-1/2 z-10 bg-white p-2 rounded-md shadow'>
        <h5 className='text-sm text-center text-gray-700'><i className='bi bi-clock me-1'></i>時刻 <span className='text-xs text-gray-500'>{new Date(Number(sliderValue)).toLocaleTimeString()}</span></h5>
        <input type='range' min={sliderMin} max={sliderMax} value={sliderValue} step={60000} onChange={(e) => {updateMarkers(e)}} className='w-80' />
        <div className='flex justify-between'>
          <span className='text-xs text-gray-500'>{new Date(sliderMin).toLocaleTimeString()}</span>
          <span className='text-xs text-gray-500'>{new Date(sliderMax).toLocaleTimeString()}</span>
        </div>
      </div>

      <TeamInfoModal onClose={() => setIsOpen(false)} team={modalTeam} isOpen={modalIsOpen} members={members} location={modalLocation} />
    </div>
  );
};

export default Map;